var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.53,
    height: 56,
    viewBox: "0 0 57.53 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_ar",
    transform: "translate(-449.979 -302.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2023",
    d: "M16.583.5H8.948A8.448,8.448,0,0,0,.5,8.948v7.636",
    transform: "translate(450.479 302.735)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2025",
    d: "M.5,61.919v7.636A8.448,8.448,0,0,0,8.948,78h7.636",
    transform: "translate(450.479 279.232)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2027",
    d: "M78,16.583V8.948A8.448,8.448,0,0,0,69.555.5H61.919",
    transform: "translate(428.507 302.735)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2029",
    d: "M61.919,78h7.636A8.448,8.448,0,0,0,78,69.555V61.919",
    transform: "translate(428.507 279.232)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_17",
    y2: 16.151,
    transform: "translate(478.023 331.732)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2030",
    d: "M49.031,26.878l-14.5,9.36-14.5-9.36,14.5-9.36Z",
    transform: "translate(443.491 296.193)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2031",
    d: "M49.031,32.091V48.242l-14.5,9.36-14.5-9.36V32.091",
    transform: "translate(443.491 290.399)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenAr);
export default __webpack_public_path__ + "static/media/open_ar.1ee6d6e4d3b3274c77fb555c78d1fb74.svg";
export { ForwardRef as ReactComponent };